import { render, staticRenderFns } from "./BrandEdit.template.vue?vue&type=template&id=b77d245a&scoped=true&"
var script = {}
import style0 from "./BrandEdit.template.vue?vue&type=style&index=0&id=b77d245a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77d245a",
  null
  
)

export default component.exports